<template>
    <BreadCrumb PageTitle="Faire un paiement" />
    <Paiement />
  </template>
  
  <script lang="ts">
    import { defineComponent } from "vue";
  
    import BreadCrumb from "../../components/Common/BreadCrumb.vue";
    import Paiement from "../../components/Paiement/Paiement.vue";
    export default defineComponent({
      name: "PaiementPage",
      components: {
        BreadCrumb,
        Paiement,
      },
    });
  </script>